module.exports = __webpack_public_path__ + "static/wendy-87430126d2a48c5f8a691b02caeb1ad4.png";